/* rc-lightbox — shared fullscreen viewer.
   Event-delegated + idempotent (survives AJAX-added galleries). Load once, defer.
   Triggers: [data-rc-lb-trigger][data-rc-lb-group][data-rc-lb-index][data-rc-lb-src][data-rc-lb-alt]
   Cycles within the clicked group. */
(function () {
  if (window.__rcLightboxInit) return;
  window.__rcLightboxInit = true;

  var dialog, stage, items = [], current = 0, touchX = null;

  function dlg() { return dialog || (dialog = document.querySelector('[data-rc-lightbox]')); }

  function preload(i) {
    if (!items.length) return;
    var s = items[(i + items.length) % items.length].getAttribute('data-rc-lb-src');
    if (s) { var im = new Image(); im.src = s; }
  }

  function render(i) {
    if (!items.length) return;
    current = (i + items.length) % items.length;
    var it = items[current];
    // Reuse the <img> (no blank flash on change) and preload neighbours so prev/next is instant.
    var img = stage.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'rc-lightbox__img';
      img.decoding = 'async';
      stage.appendChild(img);
    }
    img.src = it.getAttribute('data-rc-lb-src');
    img.alt = it.getAttribute('data-rc-lb-alt') || '';
    preload(current + 1);
    preload(current - 1);
  }

  function open(clicked) {
    var d = dlg();
    if (!d) return;
    stage = d.querySelector('[data-rc-lb-stage]');
    // Every lightbox-able image on the page is one cycle — gather them all,
    // open at the clicked one; prev/next wraps through every image in DOM order.
    items = Array.prototype.slice.call(document.querySelectorAll('[data-rc-lb-trigger]'));
    if (!items.length) return;
    var idx = items.indexOf(clicked);
    render(idx < 0 ? 0 : idx);
    if (!d.open) d.showModal();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rc-lb-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }
    var d = dlg();
    if (!d || !d.open) return;
    if (e.target.closest('[data-rc-lb-close]')) { d.close(); return; }
    if (e.target.closest('[data-rc-lb-prev]')) { e.preventDefault(); render(current - 1); return; }
    if (e.target.closest('[data-rc-lb-next]')) { e.preventDefault(); render(current + 1); return; }
    // backdrop click (outside the inner wrapper) closes
    var inner = d.querySelector('[data-rc-lb-inner]');
    if (inner && !inner.contains(e.target)) d.close();
  });

  document.addEventListener('keydown', function (e) {
    var d = dlg();
    if (!d || !d.open) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); render(current - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); render(current + 1); }
  });

  document.addEventListener('touchstart', function (e) {
    var d = dlg(); if (d && d.open) touchX = e.changedTouches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var d = dlg(); if (touchX === null || !d || !d.open) return;
    var delta = e.changedTouches[0].clientX - touchX;
    if (Math.abs(delta) > 40) render(delta < 0 ? current + 1 : current - 1);
    touchX = null;
  });
})();
